export default __webpack_public_path__ + "static/media/icon-camera.c265ef9d.svg";